$(function () {
    var body = $('body');
    var nav = $('.nav');
    var burger = $('.burger');
    var nav_trigger = $('.nav').find('ul li');
    var nav_align = 'right';
    var break_point = 992;
    var browser_width = window.innerWidth;
    var nav_width = 300;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');

    nav_window.click(function (event) {
        nav_reset();
    });

    //burger click
    burger.click(function (event) {
        event.preventDefault();
        $(this).toggleClass('__active');
        if (body.hasClass('__mobile')) {
            nav_reset();
        } else {
            nav_launch();
        }
    });

    /*nav reset*/
    var nav_reset = function nav_reset() {
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul').removeClass('__active');
        burger.find('.burger-text').text('Menu');
    };

    /*nav launch*/
    var nav_launch = function nav_launch() {
        nav_window.show();
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
        burger.find('.burger-text').text('Close');
    };

    var nav_ul = $('.nav ul li > ul');
    var view_button = $('<li class="viewall"><a href="#">View</a></li>');
    var back_button = $('<li class="backto"><a href="#">Back</a></li>');
    
    
    function initMenu() {
        $(".navwrap *").unbind();

        $( ".navwrap ul").on( "mouseenter focusin", function() {
            $('.navwrap ul').each(function () {
                var elem = $(this)
                var rect = elem[0].getBoundingClientRect();
                if(rect.x + rect.width > window.innerWidth) {
                    $(this).addClass('left');
                }
            });
        });

        var browser_width = window.innerWidth;

         // nav dropdown on focus/keyboard navigation
        if (browser_width >= break_point) {
            $('.menu-item').focusin(function () {
                $(this).addClass('__active');
                $(this).children('button').attr('aria-expanded', true);
            });
            $('.menu-item').focusout(function () {
                $(this).removeClass('__active');
                $(this).children('button').attr('aria-expanded', false);
            });
            $('.menu-item').mouseover(function () {
                $(this).children('button').attr('aria-expanded', true);
            });
            $('.menu-item').mouseout(function () {
                $(this).children('button').attr('aria-expanded', false);
            });
        }

        if (browser_width < break_point) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if($(this).hasClass("open")) {
                    $(this).removeClass("open");
                    if ($(this).children('ul').length > 0) {
                        event.preventDefault();
                        $(this)
                            .parents('ul')
                            .addClass('__active');
                        $(this)
                            .children('ul')
                            .removeClass('__active');
                        $(this)
                            .children('ul')
                            .slideUp(200);
                    }
                } else {
                    $(this).addClass("open");
                    if ($(this).children('ul').length > 0) {
                        event.preventDefault();
                        $(this)
                            .parents('ul')
                            .removeClass('__active');
                        $(this)
                            .children('ul')
                            .addClass('__active');
                        $(this)
                            .children('ul')
                            .slideDown(200);
                    }
                }
            });
        }

        if (browser_width < break_point) {
            if (nav_ul.has(view_button).length == 0) {
                nav_ul.prepend(view_button);
            }
        } else {
            if (nav_ul.has(view_button).length) {
                $('.viewall').remove();
            }
            nav_reset();
        }
        

        // Touch device check
        const isTouchDevice = () => {
            return window.matchMedia("(pointer: coarse)").matches
        }
        // If desktop and touch device, disable link click and add extra view link
        if (browser_width > break_point && isTouchDevice()) {
            nav_trigger.click(function (event) {
                event.stopPropagation();
                if ($(this).children('ul').length > 0) {
                    event.preventDefault();
                }
            });
            nav_ul.prepend(view_button);
        }

        var view_all = $('.viewall');
        view_all.each(function () {
            var parent_url = $(this)
                .closest('ul')
                .siblings()
                .attr('href');
            var parent_title = $(this)
                .closest('ul')
                .siblings()
                .html();
            $(this)
                .find('a')
                .attr('href', parent_url);
            $(this)
                .find('a')
                .html('View ' + parent_title);
        });

        view_all.click(function (event) {
            event.stopPropagation();
        });
        
    }
    
    initMenu();

    $(window).on('resize', function(){
        initMenu();
    });

    $(".navwrap > .row").on( 'scroll', function(){
        console.log($(this).scrollTop());
        $('.header-burger').css('transform', 'translateY(-'+$(this).scrollTop()+'px)');
    });

});